export function getPaginationItems(currentPage: number, pageCount: number): Array<number | 'ellipsis'> {
  if (pageCount <= 0) return [];
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, index) => index);
  }

  const safeCurrentPage = Math.min(Math.max(currentPage, 0), pageCount - 1);
  const pages = new Set<number>([0, pageCount - 1, safeCurrentPage]);
  [safeCurrentPage - 1, safeCurrentPage + 1].forEach((page) => {
    if (page > 0 && page < pageCount - 1) pages.add(page);
  });

  const items: Array<number | 'ellipsis'> = [];
  let previous: number | null = null;
  Array.from(pages)
    .sort((left, right) => left - right)
    .forEach((page) => {
      if (previous !== null && page - previous > 1) items.push('ellipsis');
      items.push(page);
      previous = page;
    });

  return items;
}
